import { AssignedStatus } from '@constants/conversations';
import { AssignmentType } from '@constants/inbox';

export const buildAssigneesForView = (view, { users, agents, currentUserId }) => {
    if (view === AssignedStatus.Unassigned) return [{ value: null, type: AssignmentType.Unassigned }];
    if (view === AssignedStatus.Mine) return [{ value: currentUserId, type: AssignmentType.User }];
    return [
        ...users.map(user => ({ value: user.id, type: AssignmentType.User })),
        { value: null, type: AssignmentType.Unassigned },
        ...agents.map(agent => ({ value: agent.id, type: AssignmentType.Agent })),
    ];
};

export const clearedInboxFilters = () => ({
    timeframe: { start: null, end: null },
    from: null,
    to: null,
    showUnreadOnly: false,
});

export const isSameAssignees = (left, right) =>
    left.length === right.length &&
    left.every(item => right.some(other => other.value === item.value && other.type === item.type));

export const applyMessageStatus = (messages, { messageId, status, createdAt, metadata }) => {
    const index = messages.findIndex(m => m.id === messageId);
    if (index === -1) return null;
    const updated = messages.slice();
    updated[index] = { ...updated[index], status, createdAt, ...(metadata ? { metadata } : {}) };
    return updated;
};

export const parseMessageMetadata = metadata => {
    if (!metadata) return null;
    try {
        return JSON.parse(metadata);
    } catch {
        return null;
    }
};
